import { createFileRoute } from '@tanstack/react-router'

import { AgreementReview } from '@/features/agreements/agreement-review'
import { handoverGate } from '@/features/handover/gate'

/** The agreement, at `/bookings/{id}/agreement`. Reading and signing are one screen; a stale `?step=` still lands here. */
export const Route = createFileRoute('/_app/bookings/$bookingId_/agreement')({
  ...handoverGate(),
  component: AgreementReview,
})
